"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// This is a list of keys that should be redacted out of any payload sent through a transport
var redactedKeys = [/(First|Last|Sur|Given)Name/i, /bank/i, /expiry/i, /Gender/i, /DOB/i, /Password/i, /Medicare/i, /FlybuysNumber/i, /Email/i, /Phone/i, /line\d/i, /authorization/i];
var _default = redactedKeys;
exports["default"] = _default;